import React from "react";

import "./Contact.css";

function Contact() {
  return (
    <div className="contact-page container">
      <p className="contact-intro">
        Whether you’re building something meaningful, tackling complex
        challenges, or seeking a collaborator who blends technical clarity with
        deep empathy, I’d love to connect. Let’s bring technology, people, and
        ideas together to solve meaningful challenges.
      </p>

      <p className="signature-typewriter">
        <em>Curiosity is where meaningful solutions begin.</em>
      </p>
    </div>
  );
}

export default Contact;
